// src/components/Navbar.js
import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';
import logo from './logo.png';

function Navbar() {
    const { isAuthenticated, isAdmin, currentUser, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation(); // This hook gives you the current URL path
    const currentYear = new Date().getFullYear();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    // Function to check if a menu item is active
    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <>
        <nav className="navbar">
            <div className="navbar-left">
                <div className="navbar-brand">
                    <Link to={isAuthenticated ? '/dashboard' : '/login'}>
                        <img src={logo} alt="Call Log App" className="navbar-logo" />
                    </Link>
                </div>
                {isAuthenticated && (
                    <div className="navbar-links">
                        <Link to="/dashboard" className={`navbar-item ${isActive('/dashboard') ? 'active' : ''}`}>Dashboard</Link>
                        <Link to="/call-logs" className={`navbar-item ${isActive('/call-logs') ? 'active' : ''}`}>Call Logs</Link>
                        <Link to="/upload" className={`navbar-item ${isActive('/upload') ? 'active' : ''}`}>Upload</Link>

                        {isAdmin && (
                            <div className="navbar-dropdown">
                                <span className={`navbar-item with-dropdown ${location.pathname.startsWith('/admin') ? 'active' : ''}`}>Admin</span>
                                <div className="dropdown-content">
                                    <Link to="/admin/users" className={isActive('/admin/users') ? 'active' : ''}>User Management</Link>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {isAuthenticated ? (
                <div className="navbar-right">
                    <span className="navbar-username">
                        Hello, {currentUser.firstName}
                        {isAdmin && <span className="admin-badge">Admin</span>}
                    </span>
                    <button onClick={handleLogout} className="logout-btn">Logout</button>
                </div>
            ) : (
                <div className="navbar-menu">
                </div>
            )}
        </nav>

    <div className="copyright-banner">
        <p>&copy; {currentYear} Call Log App. All rights reserved.</p>
    </div>
        </>
    );
}

export default Navbar;